module.exports = __webpack_public_path__ + "static/img/img4.9c9aabd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img4.png
// module id = fzRy
// module chunks = 1